(function(){
    'use strict';

    const initialized = new WeakMap();

    const init = (node) => {
        if (initialized.has(node)) {
            return;
        }

        const button = node.querySelector('.newsletter-overlay__close');
        const form = node.querySelector('form');

        if (null === button || null === form) {
            return;
        }

        initialized.set(node, true);

        if (null !== localStorage.getItem('newsletter-overlay')) {
            return;
        }

        if (null !== sessionStorage.getItem('newsletter-overlay')) {
            return;
        }

        sessionStorage.setItem('newsletter-overlay', true);

        node.classList.add('show');

        button.addEventListener('click', (e) => {
            e.preventDefault();
            node.classList.remove('show');
            return false;
        });

        form.addEventListener('submit', () => {
            localStorage.setItem('newsletter-overlay', true);
            return true;
        });
    };

    document.querySelectorAll('.newsletter-overlay').forEach((element) => {
        init(element);
    });

    new MutationObserver(function (mutationsList) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function (element) {
                    if (element.matches && element.matches('.newsletter-overlay')) {
                        init(element);
                    }
                })
            }
        }
    }).observe(document, {
        attributes: false,
        childList: true,
        subtree: true
    });
})();
